import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';

import { RoleService } from '../Services/role.service';
import { HeaderService } from '../Services/header.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  styleUrls: ['../app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdminComponent implements OnInit {

  addNotesSub: Subscription;
  canAddNotes: boolean;
  addAppsSub: Subscription;
  canAddApps: boolean;

  constructor(private roles: RoleService, private header: HeaderService) {

  }

  ngOnInit() {
    this.header.clearAlerts();
    this.header.checkAuth(true);
    this.header.setBreadcrumbs(null, null, null, true);

    this.addNotesSub = this.roles.canAddNote$.subscribe(
      auth => {
        this.canAddNotes = auth;
      });

    this.addAppsSub = this.roles.canAddApp$.subscribe(
      auth => {
        this.canAddApps = auth;
      });

    this.roles.getUserRoles();
  }
}

